module.exports = __webpack_public_path__ + "img/chat_d.fa6841a7.png";